import gql from 'graphql-tag'

export const GET_RFIDS = gql`
  query GetRfids($filter: GetRfidFilter) {
    getRfids(filter: $filter) {
      getRfids {
        rfidStatistic {
          activated
          inactivated
          notAssigned
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        data {
          rfid
          driverId
          description
          isActive
          driver {
            fullname
            isActive
          }
          assignedDate
        }
      }
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const UPDATE_RFID = gql`
  mutation UpdateRfid($input: UpdateRfidInput!) {
    updateRfid(input: $input) {
      updateRfid {
        companyId
        rfid
        driverId
        description
        isActive
        assignedDate
      }
      isSuccessful
      message
      status
      errorName
      errorCode
    }
  }
`

export const UPDATE_RFID_STATUSES = gql`
  mutation UpdateRfidStatuses($input: UpdateRfidStatusInput!) {
    updateRfidStatuses(input: $input) {
      updateRfidStatuses {
        data {
          companyId
          rfid
          driverId
          description
          isActive
          assignedDate
        }
      }
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const GET_RFID_LOGS = gql`
  query GetRfidLogs($filter: RfidAuditLogInput) {
    getRfidLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      getRfidAuditLogs {
        data {
          time
          identifier
          entity
          action
          detail
          user
          companyId
          object
          oldData
          newData
          actionType
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_RFID_DETAIL = gql`
  query GetRfidReader($filter: GetRfidReaderFilter!) {
    getRfidReader(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rfidReader {
        vehicle {
          licensePlate
          sensor {
            statusBool
            statusText
            sensorType {
              sensorName
            }
            sensorCode
          }
        }
        rfid2Vehicle {
          rfidMaster {
            rfid
            driver {
              fullname
            }
          }
          state
          deviceIndex
        }
      }
    }
  }
`

export const UNASSIGN_RFID_READER = gql`
  mutation UnassignRfidReader($input: UnassignRfidReaderInput!) {
    unassignRfidReader(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      unassignRfidReader {
        data {
          deviceIndex
          state
          rfid
          vehicleId
          updatedOn
        }
      }
    }
  }
`

export const GET_RFID_READERS = gql`
  query GetRfidReaders($filter: GetRfidReadersFilter) {
    getRfidReaders(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      getRfidReaders {
        rfidReadersStatistic {
          activated
          inactivated
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        data {
          vehicleId
          vehicle {
            id
            licensePlate
            sensor {
              sensorCode
              statusBool
              statusText
              sensorType {
                sensorName
              }
            }
          }
          driverData {
            driverId
            rfid
            deviceIndex
            updatedOn
            state
            driver {
              userId
              fullname
            }
          }
        }
      }
    }
  }
`

export const ASSIGN_RFID_READER = gql`
  mutation AssignRfidReader($input: AssignRfidReaderInput!) {
    assignRfidReader(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      assignRfidReader {
        deviceIndex
        rfid
        rfidMaster {
          driver {
            fullname
          }
        }
        state
        updatedOn
        vehicleId
      }
    }
  }
`
